import axios from 'axios'
import {getCookie,clearCookie} from '@/common/js/common'

// axios基本配置
axios.defaults.timeout = 10000
axios.defaults.baseURL = 'http://xw.hd199.com'
axios.defaults.withCredentials = false


// http request 拦截器
axios.interceptors.request.use(
	config => {
		const sid = getCookie('sid') ? getCookie('sid') : '';
		if (sid) {
			config.headers.sid = sid
		}
		return config
	},
	err => {
		return Promise.reject(err)
	}
)
// http response 拦截器
axios.interceptors.response.use(
    response => {
        switch (response.data.code) {
            case 1:
                return response.data;
            case "200":
                return response.data;
			case 100:
				window.vm.$message({
					message:'请先登录',
					type:'error',
					onClose:function(){
						window.location.href = `http://lt.hd199.com/user/username-login?ershou`;
					}
				});
				break;
			case 101:
				window.vm.$message({
					message:'登录失效',
					type:'error',
					onClose:function(){
						window.location.href = `http://lt.hd199.com/user/username-login?ershou`;
					}
				});
				//清空cookie
				clearCookie('dzq_user_id');
				clearCookie('sid');
				clearCookie('access_token');
				break;
			case 0:
				window.vm.$message({
					type:'error',
					message:response.data.msg,
				})
				if (response.data.msg == '无此商品') {
						window.router.push('/');
						location.reload()
				}
				break;
			default:
				return response.data;
        }
    },
    error => {
        return Promise.reject(error)
    })

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
    })
}

/**
 * get 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get (url, data) {
    return new Promise((resolve, reject) => {
        axios.get(url, data)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
    })
}

/**
 * put 请求方法
 * @param url
 * @param id
 * @param data
 * @returns {Promise}
 */
export function put (url, id, data) {
    return new Promise((resolve, reject) => {
        axios.put(url + id, data)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
    })
}

/**
 * delete 请求方法
 * @param url
 * @param id
 * @returns {Promise}
 */
export function _delete (url, id) {
    return new Promise((resolve, reject) => {
        axios.delete(url + id)
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
    })
}

export function upload(form) { 
	return new Promise((resolve, reject) => {
		axios({
			url:'/apis/common/upload',
			method: 'post',
			data: form,
			headers: {'Content-type':'multipart/form-data'}
		}).then(response => { 
			
				
				resolve(response)
			
			
		})
    })
}
export default axios



// WEBPACK FOOTER //
// ./src/common/js/http.js